module.exports = __webpack_public_path__ + "static/artist2-fd0ae1381851f5ed7417c1ccf7490c94.jpg";